<button (click)="openDialog(titel, inhalt)" type="button">
  <mat-icon>{{ icon }}</mat-icon>
  <span>{{ titel }}</span>
</button>
